
import { useEffect, useState } from 'react';
import { Button, Divider, Space, Table, Tag, Typography, Form, DatePicker, Row, Col, Select, message } from 'antd';
import { DownloadOutlined, } from '@ant-design/icons';
import { fetchRegisteredUsersReportData, getRegisteredUsersReportCsv } from '../../_services/reports.service';
import moment from "moment";


const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterForm = ({ initialValue, hasData, onSearch, onExport, exporting }) => {
    const [form] = Form.useForm();

    const exportData = () => {
        const values = form.getFieldsValue();
        onExport(values);
    };

    const onFormValuesChange = (changedValues, allValues) => {
        onSearch(allValues)
    }

    return (
        <Form form={form} initialValues={initialValue} layout="inline" onValuesChange={onFormValuesChange} style={{ marginBottom: 24 }}>
            <Row style={{ width: '100%' }} justify="space-between" align="middle">
                <Col>
                    <Space>
                        <Form.Item name="range">
                            <RangePicker
                                allowClear={false}
                                placeholder={['Start Date', 'End Date']}
                            />
                        </Form.Item>
                        <Form.Item name="userType" label="User Type">
                            <Select
                                placeholder="Select User Type"
                                style={{ width: 140 }}
                                defaultValue=""
                            >
                                <Option value="">All</Option>
                                <Option value="instructors">Instructors</Option>
                                <Option value="users">Users</Option>
                            </Select>
                        </Form.Item>
                    </Space>
                </Col>

                <Col>
                    <Space>
                        <Form.Item>
                            <Button icon={<DownloadOutlined />} onClick={exportData} disabled={!hasData} loading={exporting}>
                                Export to CSV
                            </Button>
                        </Form.Item>
                    </Space>
                </Col>
            </Row>
        </Form>
    );
};

const ReportRegisteredUsers = () => {

    const [loading, setLoading] = useState(false);
    const [hasData, setHasData] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [error, setError] = useState();
    const [data, setData] = useState([]);
    const [formValue, setFormValue] = useState({
        range: [moment().startOf("month"), moment().endOf("month")],
        userType: '',
    });
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
    });

    const columns = [
        {
            title: 'User ID',
            dataIndex: 'id',
            render: (_, { id }) => (
                <span>{id}</span>
            )
        },
        {
            title: 'Name',
            dataIndex: 'firstName',
            render: (_, { firstName, lastName, username }) => (
                <Space direction='vertical' size={0}>
                    <span>
                        {firstName} {lastName}
                    </span>
                    <Text type="secondary">
                        {username}
                    </Text>
                </Space>
            )
        },
        {
            title: 'Email',
            dataIndex: 'email',
            render: (_, { email }) => (
                <span>{email}</span>
            )
        },
        {
            title: 'User Type',
            dataIndex: 'userType',
            render: (_, { userType }) => (
                <Tag color={userType === "instructor" ? "blue" : "default"}>
                    {userType === "instructor" ? "Instructor" : "User"}
                </Tag>
            )
        },
        {
            title: 'Date Joined',
            dataIndex: 'dateJoined',
            render: (_, { dateJoined }) => (
                <>
                    {moment(dateJoined).format("L")}
                </>
            )
        },
    ];

    const fetchData = ({ current, pageSize }) => {
        setLoading(true);
        setError(null);

        fetchRegisteredUsersReportData(formValue, {
            page: current,
            pageSize,
        }).then(response => {
            setData(response.data);
            setHasData(response.data.length > 0)
            setLoading(false);
            setPagination((prev) => ({
                ...prev,
                current,
                pageSize,
                total: response.total,
            }));
        }).catch(error => {
            setError("Something went wrong when fetch data!");
            setHasData(false);
            setLoading(false);
        })
    }

    const handleTableChange = (newPagination) => {
        fetchData({
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
    };

    const exportToCsv = (data) => {
        setExporting(true);
        getRegisteredUsersReportCsv(data).then(() => {
            message.success("Report Downloaded!");
            setExporting(false);
        }).catch(error => {
            message.error("Something went wrong when export data!");
            setExporting(false);
        })
    }

    useEffect(() => {
        fetchData({
            current: pagination.current,
            pageSize: pagination.pageSize,
        });
    }, [formValue]);

    return <div>
        <h2>
            Registered Users Report
        </h2>
        <Divider />
        <FilterForm hasData={hasData} initialValue={formValue}
            exporting={exporting}
            onSearch={(formData) => { setFormValue(formData) }}
            onExport={(formData) => { exportToCsv(formData) }} />

        <Table
            columns={columns}
            size="middle"
            rowKey={record => record.id}
            dataSource={data}
            locale={{
                emptyText: error || 'No Data found'
            }}
            loading={loading}
            pagination={{
                ...pagination,
                showTotal: (total) => `Total ${total} records`,
            }}
            onChange={handleTableChange}
        />
    </div>
}

export default ReportRegisteredUsers;
